import React from "react";
import styled from "styled-components";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";


const Button = styled.a`

position: fixed;

right: 20px;

bottom: 20px;

z-index: 9999;


display:flex;

align-items:center;

gap:10px;


background:#25D366;

color:white;

text-decoration:none;


padding:12px 18px;

border-radius:50px;


font-size:1rem;

font-weight:600;


box-shadow:0 4px 12px rgba(0,0,0,0.3);


transition:transform .3s ease;


&:hover{

transform:scale(1.08);

}


@media(max-width:600px){

padding:12px;

border-radius:50%;


span{

display:none;

}

}

`;



const Icon = styled(FaWhatsapp)`

font-size:2rem;

`;




const WhatsAppButton:React.FC=()=>{

const { t, i18n } = useTranslation();


return (

<Button

href="https://wa.me/31684629633"

target="_blank"

rel="noopener noreferrer"

>


<Icon/>


<span>

{i18n.language === "ar" ? "لديك أسئلة؟ تواصل معي" : t("whatsapp")}

</span>


</Button>

);


};


export default WhatsAppButton;
